import InfoCardBlock from 'components/common/form/custom/ReplicatedInfo/InfoCardBlock';
import { WebFormCustomFields } from 'store/ui-stores/web-form/webFormStore';
import {
  ReplicatedCustomInfo,
  ZywaveMemorialHermannCompensationEE,
  ZywaveMemorialHermannExemptEE,
} from 'types/formService';
import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { createStyles } from 'components/common/form/custom/ReplicatedInfo/InfoCardModal/styles';
import { InputText, Select } from '@insurancemenu/imenu-components-lib';
import React from 'react';

const asExemptEE = (info: ReplicatedCustomInfo): ZywaveMemorialHermannExemptEE => info as ZywaveMemorialHermannExemptEE;
const asCompensationEE = (info: ReplicatedCustomInfo): ZywaveMemorialHermannCompensationEE =>
  info as ZywaveMemorialHermannCompensationEE;

export const getExemptEEBlock = (): JSX.Element => {
  return (
    <InfoCardBlock
      key="memorialHermannExemptEE"
      componentName="memorialHermannExemptEE"
      amountOfAdditionalCards={4}
      customModalHeaderName="Employee"
      addButtonName="Add Exempt Employee"
      getCustomComponentField={(customField: WebFormCustomFields) => {
        return customField.memorialHermannExemptEE;
      }}
      columns={[
        {
          title: 'Name',
          width: '17rem',
          getValue: (info) => `${asExemptEE(info).eeFirstName} ${asExemptEE(info).eeLastName}`,
        },
        { title: 'Title', width: '13rem', getValue: (info) => asExemptEE(info).eeTitle ?? '' },
        {
          title: 'Exempt according to above requirement?',
          width: '17rem',
          getValue: (info) => asExemptEE(info).exemptFlag ?? '',
        },
      ]}
      createCustomForm={(): FormController<DefaultFormFields> => {
        return new FormController<DefaultFormFields>({
          eeFirstName: new FormControl<string>('', { validations: ['validName'], trim: true }),
          eeLastName: new FormControl<string>('', { validations: ['validName'], trim: true }),
          eeTitle: new FormControl<string>('', { validations: ['printableCharacters'], trim: true }),
          exemptFlag: new FormControl<string>(''),
        });
      }}
      customModalContent={(customForm: FormController<DefaultFormFields>): JSX.Element => {
        const classes = createStyles();
        const eeFirstName = customForm.fields.eeFirstName;
        const eeLastName = customForm.fields.eeLastName;
        const eeTitle = customForm.fields.eeTitle;
        const exemptFlag = customForm.fields.exemptFlag;
        return (
          <>
            <Select
              label="Exempt according to above requirement?"
              name="exemptFlag"
              value={exemptFlag.value?.toString()}
              options={[
                { value: 'Yes', label: 'Yes' },
                { value: 'No', label: 'No' },
              ]}
              onChange={customForm.onFieldChange}
              validationMessage={exemptFlag.unpassedValidationMsg || ''}
              validationPassed={!exemptFlag.unpassedValidationMsg}
              className={classes.regularField}
            />
            <InputText
              label="Title"
              name="eeTitle"
              maxLength={50}
              value={eeTitle.value?.toString()}
              onChange={customForm.onFieldChange}
              validationMessage={eeTitle.unpassedValidationMsg || ''}
              validationPassed={!eeTitle.unpassedValidationMsg}
              className={classes.regularField}
            />
            <InputText
              label="First Name"
              name="eeFirstName"
              maxLength={50}
              value={eeFirstName.value?.toString()}
              onChange={customForm.onFieldChange}
              validationMessage={eeFirstName.unpassedValidationMsg || ''}
              validationPassed={!eeFirstName.unpassedValidationMsg}
              className={classes.regularField}
            />
            <InputText
              label="Last Name"
              name="eeLastName"
              maxLength={50}
              value={eeLastName.value?.toString()}
              onChange={customForm.onFieldChange}
              validationMessage={eeLastName.unpassedValidationMsg || ''}
              validationPassed={!eeLastName.unpassedValidationMsg}
              className={classes.regularField}
            />
          </>
        );
      }}
    />
  );
};

export const getCompensationEEBlock = (): JSX.Element => {
  return (
    <InfoCardBlock
      key="memorialHermannCompensationEE"
      componentName="memorialHermannCompensationEE"
      amountOfAdditionalCards={3}
      customModalHeaderName="Employee"
      addButtonName="Add Employee Receiving Compensation Benefits"
      getCustomComponentField={(customField: WebFormCustomFields) => {
        return customField.memorialHermannCompensationEE;
      }}
      columns={[
        {
          title: 'Name',
          width: '17rem',
          getValue: (info) => `${asCompensationEE(info).eeFirstName} ${asCompensationEE(info).eeLastName}`,
        },
        { title: 'Title', width: '13rem', getValue: (info) => asCompensationEE(info).eeTitle ?? '' },
      ]}
      createCustomForm={(): FormController<DefaultFormFields> => {
        return new FormController<DefaultFormFields>({
          eeFirstName: new FormControl<string>('', { validations: ['validName'], trim: true }),
          eeLastName: new FormControl<string>('', { validations: ['validName'], trim: true }),
          eeTitle: new FormControl<string>('', { validations: ['printableCharacters'], trim: true }),
        });
      }}
      customModalContent={(customForm: FormController<DefaultFormFields>): JSX.Element => {
        const classes = createStyles();
        const eeFirstName = customForm.fields.eeFirstName;
        const eeLastName = customForm.fields.eeLastName;
        const eeTitle = customForm.fields.eeTitle;
        return (
          <>
            <InputText
              label="First Name"
              name="eeFirstName"
              maxLength={50}
              value={eeFirstName.value?.toString()}
              onChange={customForm.onFieldChange}
              validationMessage={eeFirstName.unpassedValidationMsg || ''}
              validationPassed={!eeFirstName.unpassedValidationMsg}
              className={classes.regularField}
            />
            <InputText
              label="Last Name"
              name="eeLastName"
              maxLength={50}
              value={eeLastName.value?.toString()}
              onChange={customForm.onFieldChange}
              validationMessage={eeLastName.unpassedValidationMsg || ''}
              validationPassed={!eeLastName.unpassedValidationMsg}
              className={classes.regularField}
            />
            <InputText
              label="Title"
              name="eeTitle"
              maxLength={50}
              value={eeTitle.value?.toString()}
              onChange={customForm.onFieldChange}
              validationMessage={eeTitle.unpassedValidationMsg || ''}
              validationPassed={!eeTitle.unpassedValidationMsg}
              className={classes.regularField}
            />
          </>
        );
      }}
    />
  );
};
